import { CreateTournamentScreen } from '@/screens/index'

export default function () {
  return <CreateTournamentScreen />
}
